// extracted by mini-css-extract-plugin
export default {"color1":"#6366f1","green2":"#34d399","green1":"#10b981","red1":"#f43f5e","red2":"#e11d48","black1":"#0f1322","black2":"#181b34","white1":"#f8fafc"};